import { render } from "./HandleMessage.vue?vue&type=template&id=a9834c26&scoped=true"
import script from "./HandleMessage.vue?vue&type=script&lang=js"
export * from "./HandleMessage.vue?vue&type=script&lang=js"

import "./HandleMessage.vue?vue&type=style&index=0&id=a9834c26&scoped=true&lang=scss"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9834c26"]])

export default __exports__